import { useEffect, useCallback, useRef } from 'react';

export const useSpacebarRecording = (isRecording, canRecord, startRecording, stopRecording) => {
  const isRecordingRef = useRef(isRecording);
  const canRecordRef = useRef(canRecord);
  
  // Mettre à jour les refs
  useEffect(() => {
    isRecordingRef.current = isRecording;
  }, [isRecording]);
  
  useEffect(() => {
    canRecordRef.current = canRecord;
  }, [canRecord]);

  const handleKeyDown = useCallback((e) => {
    console.log('🔥 KeyDown:', e.code, 'Recording:', isRecordingRef.current, 'CanRecord:', canRecordRef.current, 'FROM:', startRecording.name || 'unknown');
    
    // Vérifier si on est dans un input/textarea
    if (document.activeElement && (document.activeElement.tagName === 'INPUT' || 
        document.activeElement.tagName === 'TEXTAREA' ||
        document.activeElement.contentEditable === 'true')) {
      return;
    }

    if (e.code === 'Space' && !e.repeat) {
      e.preventDefault();
      
      // TOGGLE : si pas en train d'enregistrer -> commencer, sinon -> arrêter (UNIQUEMENT si canRecord)
      if (!isRecordingRef.current && canRecordRef.current) {
        console.log('🎤 DÉMARRAGE enregistrement via barre d\'espace');
        startRecording();
      } else if (isRecordingRef.current && canRecordRef.current) {
        console.log('🛑 ARRÊT enregistrement via barre d\'espace');
        stopRecording();
      }
    }
  }, [startRecording, stopRecording]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};